import {useMemo} from 'react';
import assert from 'assert-ts';
import {Concept} from 'types';
import type {LinkedValueSearchPageConfig} from 'sceneExtensions/extensions/linkedValueSearch/types';
import {FieldExtensionEnum} from 'sceneExtensions/types';

export const useLinkedValueSearchPageConfig = (
  agentId: string | undefined,
): LinkedValueSearchPageConfig | undefined => {
  return useMemo(
    () =>
      agentId
        ? {
            type: FieldExtensionEnum.linkedValueSearch,
            sourceField: {
              fieldId: 'agentPage',
              fieldConfig: {
                entity: Concept.agent,
                sourceEntityId: agentId,
              },
            },
            setSourceValue: (_target, action) => {
              assert(
                false,
                'useLinkedValueSearchPageConfig: Unexpected action',
                {
                  action,
                },
              );
            },
          }
        : undefined,
    [agentId],
  );
};
